import { Meta, Title } from '@angular/platform-browser';
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { Subscription } from 'rxjs';
import { services } from '../../services';
import { TranslationService } from '../../../../../../shared/services/translations.service';
import { DivisionsService } from '../../../../../../shared/modules/core/services/divisions.service';
import { LanguageChangeService } from '../../../../../../shared/services/language-change.service';

@Component({
  selector: 'app-divisions',
  templateUrl: './lol-divisions.component.html'
})
export class LolDivisionsComponent {
  protected readonly DivisionsService = DivisionsService;
  divisionService: typeof DivisionsService = DivisionsService;

  service = 'divisions';
  availableServices = services['lol'].filter(service => service.service !== this.service);

  serviceParams = {
    game: 'lol',
    service: 'divisions',
    type: 'solo',
    title: {
      en: 'Division Boosting',
    },
    subtitle: {
      en: 'Achieve Your Desired Rank Using Our LoL Boosting Services',
      fr: 'Atteins le rang souhaité grâce à nos services de boost LoL',
      de: 'Erreiche deinen gewünschten Rang mit unseren LoL-Boosting-Diensten',
      pt: 'Alcança o teu rank desejado com os nossos serviços de boost LoL',
      es: 'Alcanza el rango que deseas con nuestros servicios de boost LoL',
    },
    start: DivisionsService.getValueByRank('Silver I', 'lol'),
    desired: DivisionsService.getValueByRank('Gold IV', 'lol')
  }

  serviceFaqs = {
    en: [
      {
        question: "What Is A Division Elo Boost?",
        answer: "A Division Boost means a pro player helps you advance through ranked divisions, either by playing on your account or with you."
      },
      {
        question: "When Will I Have A Booster Ready To Start?",
        answer: "The average wait time is 5 minutes, but it can vary based on factors such as rank, champions or queue."
      },
      {
        question: "Can I Play With The Booster In Duo Queue Boosting?",
        answer: "Indeed, you can. To accomplish this, go to the order customization menu and select \"Duo\" before clicking \"Buy Boost Now.\""
      },
      {
        question: "Can I Choose My Preferred Champions/Roles And Summoner Spell Order?",
        answer: "Yes, you can. Click the \"Choose your Roles\" and \"Choose your Champions\" options in the order customization menu to make it happen."
      },
      {
        question: "Can I Play While The Order Is Active?",
        answer: "Yes, unless you want to queue in the same ranking mode as the bought service. Other than that, schedule it in the order chat with your booster."
      },
      {
        question: "Can I Request The Same Booster For A Future Purchase?",
        answer: "Yes! Click the heart icon inside the order dashboard to favorite a booster, then easily reassign them to your future orders."
      }
    ],
    fr: [
      {
        question: "Qu\'est-ce qu\'un Boost d\'Elo de Division?",
        answer: "Un boost de division signifie qu\'un joueur professionnel vous aide à progresser à travers les divisions classées, soit en jouant sur votre compte, soit en jouant avec vous."
      },
      {
        question: "Quand le Booster sera-t-il prêt à commencer?",
        answer: "Le temps d\'attente moyen est de 5 minutes, mais il peut varier en fonction de facteurs tels que le rang, les champions ou le mode."
      },
      {
        question: "Puis-je jouer avec le Booster en Boosting Duo?",
        answer: "En effet, vous pouvez le faire. Pour ce faire, allez dans le menu de personnalisation de la commande et sélectionnez \"Duo\" avant de cliquer sur \"Acheter Boost maintenant\"."
      },
      {
        question: "Puis-je choisir mes champions/rôles préférés et l\'ordre des sorts d\'invocateur?",
        answer: "Oui, vous le pouvez. Cliquez sur les boutons 'Choisissez vos Rôles' et 'Choisissez votre Champion' dans le menu de personnalisation de la commande pour le faire."
      },
      {
        question: "Puis-je jouer pendant que la commande est active?",
        answer: "Oui, sauf si vous voulez jouer dans le même mode classé que le service acheté. Dans le cas contraire, planifiez-le dans le chat de commande avec votre booster."
      },
      {
        question: "Puis-je demander le même booster pour un prochain achat?",
        answer: "Oui ! Cliquez sur l\'icône en forme de cœur dans le tableau de bord de commande pour ajouter un booster en favori, puis réassignez-le facilement à vos prochaines commandes."
      }
    ],
    de: [
      {
        question: "Was ist ein Division Elo Boost?",
        answer: "Bei einem Division-Boost hilft dir ein Profi-Spieler beim Aufstieg in der Rangliste, indem er entweder auf deinem Account oder mit dir zusammen spielt."
      },
      {
        question: "Wann habe ich einen Booster startklar?",
        answer: "Die Durchschnittliche Wartezeit ist 5 Minuten, kann aber je nach Rang, Champion oder Warteschlange variieren."
      },
      {
        question: "Kann ich mit dem Booster im Duo Queue Boosting spielen?",
        answer: "Ja, das kannst du. Gehe dazu in das Menü zur Bestellungsanpassung und wähle \"Duo\" aus, bevor du auf \"Boost Jetzt Kaufen\" klickst."
      },
      {
        question: "Kann ich meine bevorzugten Champions/Rollen und die Reihenfolge der Beschwörerzauber wählen?",
        answer: "Ja, das können Sie. Klicken Sie auf die Schaltflächen 'Wähle deine Rollen' und 'Wähle deinen Champion' im Bestell-Anpassungsmenü, um es zu tun."
      },
      {
        question: "Kann ich spielen, während die Bestellung aktiv ist?",
        answer: "Ja, es sei denn, du möchtest im gleichen Ranking-Modus wie der gekaufte Dienst spielen. Ansonsten planst du das mit deinem Booster im Auftragschat."
      },
      {
        question: "Kann ich denselben Booster auch für einen späteren Kauf anfordern?",
        answer: "Ja! Klicke im Bestell-Dashboard auf das Herzsymbol, um einen Booster zu deinen Favoriten hinzuzufügen, und weise ihn dann ganz einfach zukünftigen Bestellungen zu."
      }
    ],
    pt: [
      {
        question: "O que é um Division Elo Boost?",
        answer: "Um Division Boost significa que um jogador profissional ajuda-te a subir de rank, jogando na tua conta ou contigo."
      },
      {
        question: "Quando terei um booster pronto para começar?",
        answer: "O tempo médio de espera é de 5 minutos, mas pode variar dependendo de fatores como ranking, champions e queues."
      },
      {
        question: "Posso Jogar com o Booster em Duo Queue?",
        answer: "Sim, podes. Para fazer isso, vê acima no menu de personalização do serviço e seleciona \"Duo\" antes de clicar em \"Comprar Boost Agora\"."
      },
      {
        question: "Posso Escolher Os Meus Champions/Roles Favoritos E A Ordem Dos Spells?",
        answer: "Sim, podes. Clica nas opções \"Escolhe os teus Roles\" e \"Escolhe os teus Champions\" no menu de personalização do serviço para o fazer."
      },
      {
        question: "Posso Jogar Enquanto O Serviço Está Activo?",
        answer: "Sim, a menos que queiras fazê-lo no mesmo modo de jogo do serviço comprado. Excepto isso, basta falares e agendares com o teu booster."
      },
      {
        question: "Posso escolher o mesmo Booster para uma compra futura?",
        answer: "Sim! Clica no ícone de coração dentro do painel do pedido para marcar um booster como favorito e depois escolhe-o facilmente nos teus próximos pedidos."
      }
    ],
    es: [
      {
        question: "¿Qué es un Division Elo Boost?",
        answer: "Un Division Boost significa que un jugador profesional te ayuda a avanzar en las divisiones clasificatorias, ya sea jugando en tu cuenta o contigo."
      },
      {
        question: "¿Cuándo tendré un booster listo para funcionar?",
        answer: "El tiempo medio de espera es de 5 minutos, pero puede variar en función de factores como el rango, los campeones o la cola."
      },
      {
        question: "¿Puedo jugar con los boosters en Duo Queue Boosting?",
        answer: "Efectivamente, puedes hacerlo. Para ello, ve al menú de personalización del pedido y selecciona \"Duo\" antes de hacer clic en \"Comprar Boost ahora\"."
      },
      {
        question: "¿Puedo elegir mis campeones/roles preferidos y el orden de los hechizos de invocador?",
        answer: "Sí, puedes hacerlo. Haz clic en las opciones \"Elige tus roles\" y \"Elige tus campeones\" en el menú de personalización del pedido para que esto suceda."
      },
      {
        question: "¿Puedo jugar mientras la orden está activa?",
        answer: "Sí, a menos que quieras hacer cola en el mismo modo de clasificación que el servicio comprado. Aparte de eso, prográmalo en el chat de órdenes con tu booster."
      },
      {
        question: "¿Puedo solicitar el mismo booster para una futura compra?",
        answer: "¡Sí! Haz clic en el ícono de corazón dentro del panel del pedido para añadir un booster a favoritos y así poder reasignarlo fácilmente en tus futuros pedidos."
      }
    ]
  }

  private page = {
    title: {
      en: "LoL Boost - Rank & Division Boosting for League of Legends",
      fr: "Boost LoL - Boosting de rangs et de divisions sur League of Legends",
      de: "LoL Boost - Rank & Division Boosting für League of Legends",
      pt: "LoL Boost - Rank e Division Boosting para League of Legends",
      es: "LoL Boost - Ranking y Division Boosting para League of Legends",
    },
    metaDescription: {
      en: "Sign up to the best ELO & LOL Boosting on the planet! Our services are 100% Safe and Secure, Guaranteed!",
      fr: "Souscrivez au meilleur Boosting d\'ELO LOL de la planète ! Nos services sont 100% sûrs et sécurisés, c\'est garanti!",
      de: "Melde dich für das beste ELO- und LOL-Boosting der Welt an! Unser Service ist 100% sicher, garantiert!",
      pt: "Inscreve-te no melhor serviço de Boosting de ELO e LOL do planeta! Os nossos serviços são 100% seguros e protegidos, garantidos!",
      es: "¡Registrate en el mejor ELO & LOL Boosting del planeta! Nuestros servicios son 100% seguros, ¡garantizado!",
    }
  }

  private langChangeSubscription: Subscription;
  private lang: string = 'en';

  constructor(
    private meta: Meta,
    private title: Title,
    private route: ActivatedRoute,
    private router: Router,
    private translationService: TranslationService,
    private cookie: CookieService,
    private languageChangeService: LanguageChangeService
  ) {
    this.route.params.subscribe(params => {
      if (Object.keys(params).length === 0) {
        const url = this.router.url.split('/');
        if (this.translationService.validLangs.includes(url[1])) {
          this.lang = url[1];
        } else {
          this.lang = this.cookie.get('gg-lang') || 'en';
        }
      } else {
        this.lang = params['lang'] || 'en';
      }
      this.updateTitles()
    });

    this.langChangeSubscription = this.languageChangeService.languageChanged.subscribe((newLang: string) => {
      this.lang = newLang;
      this.updateTitles();
    });
  }

  ngOnDestroy(): void {
    if (this.langChangeSubscription) {
      this.langChangeSubscription.unsubscribe();
    }
  }

  private updateTitles() {
    this.title.setTitle(this.page.title[this.lang] || this.page.title['en']);
    this.meta.updateTag(
      {
        name: 'description',
        content: this.page.metaDescription[this.lang] || this.page.metaDescription['en']
      }
    );
  }
}